<script setup>
import { useStore } from "@/Stores/domain";
import { computed } from "vue";

const store = useStore();
const user = computed(() => store.user);

const props = defineProps({
    message: String,
    messageIndex: Number,
});
</script>

<template>
    <div class="flex items-start self-end gap-3">
        <img class="size-8 flex-none bg-gray-800 rounded-md" :src="user?.profile_photo_url" />
        <div class="p-3 text-sm leading-6 text-gray-900 whitespace-pre-wrap bg-gray-100 rounded-lg dark:text-white dark:bg-gray-800">
            {{ message }}
        </div>
    </div>
</template>
